import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import { Form, Row, Stack } from 'react-bootstrap';

import FormField from '@components/Form/FormField';
import { IFinancialAssistanceForm } from '@customTypes/requisition';

const ATTESTATION_ITEMS = [
  'I hereby acknowledge the above information is true and correct.',
  'I authorize MyOme to verify the above information for the sole purpose of assessing financial need, including the right to seek supporting documentation for the above request.',
  'I understand that if I do not qualify, I will be notified and MyOme will bill me. I hereby acknowledge that I am neither related to, nor employed by, the provider who ordered the testing.',
  'I understand and agree that MyOme, inc. Reserves the right at any time and without notice to modify the application form, to modify or terminate this program, and to audit the information I have provided on this application.',
  'I further certify and agree that I will not seek reimbursement or credit for this testing from any insurer, health maintenance organization, government program or other source of financial assistance.',
];

const AttestationFieldSet = () => {
  const { errors, touched, submitCount, values, handleChange, setFieldValue } =
    useFormikContext<IFinancialAssistanceForm>();

  return (
    <fieldset className='d-flex flex-column attestation-fieldset'>
      <legend className='text-center'>Attestation</legend>
      <Stack aria-labelledby='fset_attestationDesc' gap={2}>
        <p id='fset_attestationDesc' className='fw-bold mb-1 fs-sm text-center'>
          By checking the box below, you attest that:
        </p>
        <ol className='attestation-list'>
          {ATTESTATION_ITEMS.map((item, index) => (
            <li key={index} className='fs-xs'>
              {item}
            </li>
          ))}
        </ol>

        <Form.Check
          id='tos_consent'
          className={`fs-sm tos-consent-checkbox ${values.tos_consent ? 'checked' : ''}`}
          onChange={e => setFieldValue('tos_consent', e.target.checked)}
          checked={values.tos_consent}
          isInvalid={(touched.tos_consent || submitCount > 0) && !!errors.tos_consent}
          type='checkbox'
          label='By checking this box I agree to the above terms'
        />

        <Row>
          <FormField cols={6} name='signature' label='Full name (of signee)' required />
          <FormField
            cols={6}
            name='datetime_signed'
            label='Date signed'
            type='date'
            inputProps={{
              value: values.datetime_signed ? values.datetime_signed.slice(0, 10) : '',
              pattern: '[0-9]{4}-[0-9]{2}-[0-9]{2}',
              max: dayjs().format('YYYY-MM-DD'),
              readOnly: true,

              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                let value = e.target.value;
                if (value) {
                  value = new Date(value).toISOString();
                }
                handleChange({
                  ...e,
                  target: {
                    ...e.target,
                    value,
                    name: 'datetime_signed',
                  },
                });
              },
            }}
            required
          />
        </Row>
      </Stack>
    </fieldset>
  );
};

export default AttestationFieldSet;
